module.exports = __webpack_public_path__ + "img/dataBgImg.fcb96107.png";